import { a } from './chunk-N2KYETMV.mjs';
import { a as a$1 } from './chunk-E4ZRBNNU.mjs';
import { d as d$1 } from './chunk-6EFRS222.mjs';
import { b } from './chunk-26IU2X5T.mjs';
import l, { css } from 'styled-components';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { faHexagonExclamation } from '@fortawesome/pro-solid-svg-icons/faHexagonExclamation';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faLoader } from '@fortawesome/pro-regular-svg-icons/faLoader';
import { jsxs, jsx } from 'react/jsx-runtime';

var w=css`
  background-color: var(--color-pink-50, #fff7fb);
  border-color: var(--color-pink-600, #dd2270);

  > ${b} {
    color: var(--color-pink-600, #dd2270);
  }
`,P=css`
  background-color: var(--color-yellow-50, #fffae6);
  border-color: var(--color-yellow-600, #a66300);

  > ${b} {
    color: var(--color-yellow-600, #a66300);
  }
`,k=css`
  background-color: var(--color-blue-50, #f5faff);
  border-color: var(--color-blue-600, #0072d6);

  > ${b} {
    color: var(--color-blue-600, #0072d6);
  }
`,A=css`
  background-color: var(--color-blue-50, #f5faff);
  border-color: var(--color-blue-600, #0072d6);

  > ${b} {
    color: var(--color-blue-600, #0072d6);
  }
`,y=css`
  background-color: var(--color-green-50, #f2fcfc);
  border-color: var(--color-green-600, #108484);

  > ${b} {
    color: var(--color-green-600, #108484);
  }
`,T=css`
  flex-direction: column;
`,M=css`
  flex-direction: row;

  @media all and (max-width: 744px) {
    flex-direction: column;
  }
`,d=l.button`
  align-items: center;
  background: none;
  border-radius: var(--border-radius-small, 6px);
  border: none;
  color: var(--color-neutral-700, #425678);
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  transition: ease-in-out color;
  width: 24px;
  margin-left: var(--spacing-regular, 16px);

  :hover {
    color: var(--color-neutral-800, #1f2f4f);
  }

  :focus {
    outline: 2px solid var(--color-neutral-800, #1f2f4f);
    outline-offset: -2px;
  }
`,f=l(a)`
  align-self: flex-start;
  flex: 1 0 auto;
  flex-wrap: wrap;
`,u=l(a$1).attrs({spacing:"small"})`
  min-width: 0;
`,m=l(d$1).attrs({weight:"bold"})`
  color: var(--color-neutral-800, #1f2f4f);
`,g=l.div`
  display: flex;
  flex-grow: 1;
  gap: var(--spacing-regular, 16px);
  min-width: 0;

  ${({$size:o})=>o==="small"?T:M}
`,x=l.div`
  align-items: flex-start;
  background-color: var(--color-neutral-50, #f7faff);
  border-color: var(--color-neutral-500, #8492ae);
  border-radius: var(--border-radius-small, 6px);
  border-style: solid;
  border-width: var(--border-width-small, 2px);
  color: var(--color-neutral-700, #425678);
  display: flex;
  padding: var(--spacing-regular, 16px);

  ${({$size:o})=>o==="small"?{"max-width":"744px"}:{"max-width":"1280px"}}

  > ${b} {
    color: var(--color-neutral-700, #425678);
    margin-top: var(--spacing-x-small);
    margin-right: var(--spacing-small);
  }

  ${o=>o.$variant==="danger"&&w}
  ${o=>o.$variant==="warning"&&P}
  ${o=>o.$variant==="info"&&k}
  ${o=>o.$variant==="success"&&y}
  ${o=>o.$variant==="loading"&&A}
`;var F={loading:faLoader,danger:faHexagonExclamation,warning:faTriangleExclamation,info:faCircleInfo,success:faCircleCheck,default:faCircleInfo},e=({variant:o="default",onDismiss:i,size:s="large",children:b$1,...h})=>{let C=["danger","warning"].includes(o)?"alert":void 0,$=["info","default","success","loading"].includes(o)?"polite":void 0;return jsxs(x,{$variant:o,role:C,"aria-live":$,$size:s,...h,children:[jsx(b,{size:"regular",icon:F[o],spin:o==="loading"}),jsx(g,{$size:s,children:b$1}),i&&jsx(d,{onClick:i,"aria-label":"Close",children:jsx(b,{size:"regular",icon:faXmark})})]})};e.Root=l(e)``;e.Message=u;e.Title=m;e.Description=d$1;e.Action=f;e.displayName="Alert";var S=e;

export { S as a };
